import { useEffect, useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";

export default function DeleteWorkTimeRowModal({
  show,
  row,
  onHide,
  onDeleteRow,
  onRowDeleted,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) {
      setLoading(false);
      setError("");
    }
  }, [show]);

  const handleDelete = async () => {
    if (!row || loading) return;

    setLoading(true);
    setError("");

    const result = await onDeleteRow?.(row.id);

    setLoading(false);

    if (!result?.success) {
      setError(result?.error || "Nie udało się usunąć rekordu.");
      return;
    }

    onRowDeleted?.(row.id);
    onHide?.();
  };

  return (
    <Modal show={show} onHide={loading ? undefined : onHide} centered>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Usuń rekord czasu pracy</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-2">Czy na pewno chcesz usunąć ten rekord?</div>

        {row ? (
          <div className="text-muted small">
            Data: {String(row.date || "").slice(0, 10)} | Start:{" "}
            {String(row.start_time || "").slice(0, 8)} | Koniec:{" "}
            {row.end_time ? String(row.end_time).slice(0, 8) : "-"}
          </div>
        ) : null}

        {error ? (
          <Alert variant="danger" className="mt-3 mb-0">
            {error}
          </Alert>
        ) : null}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Anuluj
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? "Usuwanie..." : "Usuń"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}